import '../css/public.css';

(function ($) {
  $('.boffo').each(function () {
    var $el = $(this);
    var id = $el.data('boffo_id');
    var form = eval('boffoFlow_' + id);
  
    new Vue({
      el: '#boffo-' + id,
      data: {
        form: form,
        activeItem: 0
      },
      methods: {
          isEmailValid(email) {
              var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  
              return regex.test(email);
          },
          isItemValid(item) {
              if(item.value.length < 1) return false;
              if(item.type == 'email') return this.isEmailValid(item.value);
  
              return true;
          },
          isFormValid() {
              for(var i = 0; i < this.form.items.length; i++) {
                  if(!this.isItemValid(this.form.items[i])) return false;
              }
  
              return true;
          },
          fieldKeyUp(item, itemIndex, event) {
              if(event.keyCode == 13 && this.isItemValid(item)) this.activeItem = itemIndex + 1;
          },
          fieldBlur(item, itemIndex) {
              if(this.isItemValid(item)) this.activeItem = itemIndex + 1;
          },
          touchItem(itemIndex) {
              this.activeItem = itemIndex;
  
              if(this.form.items[itemIndex].type == 'select') {
                  var input = document.querySelector('.boffo-item:nth-child(' + (itemIndex + 1) + ') select');
                  input.focus();
              }
              else {
                  var input = document.querySelector('.boffo-item:nth-child(' + (itemIndex + 1) + ') input');
                  input.focus();
              }
          },
          save() {
              jQuery.ajax({
                  type: 'POST',
                  url: ajax.url,
                  data: {
                      action: "post_boffo_message",
                      items: this.form.items,
                      id: id,
                      url: window.location.href
                  },
                  success: function (data) {
                      document.querySelector('.boffo-form').classList.add('fade-out');
                      document.querySelector('.boffo-done').classList.add('fade-in');
                  },
                  error: function () {
                    
                  }
              });
          },
          cancel() {
              this.activeItem = 0;
          },
          stripSlashes(value) {
            return value.replace(/\\(.)/mg, "$1");
          }
      },
      mounted: function () {
      },
      template: `
        <div class="boffo-flow">
          <div class="boffo-form">
            <div v-for="(item, index) in form.items" class="boffo-item" v-bind:class="{ active: activeItem == index, completed: activeItem > index, queued: activeItem + 1 == index, invalid: !isItemValid(form.items[index]) }">
              <div v-if="item.type == 'text'">
                <span v-on:click="touchItem(index)">{{ stripSlashes(item.text) }}</span>
                <input type="text" placeholder="" v-model="form.items[index].value" v-on:keyup="fieldKeyUp(form.items[index], index, $event)" v-on:blur="fieldBlur(form.items[index], index)">
              </div>
              <div v-else-if="item.type == 'email'">
                <span v-on:click="touchItem(index)">{{ stripSlashes(item.text) }}</span>
                <input type="email" placeholder="" v-model="form.items[index].value" v-on:keyup="fieldKeyUp(form.items[index], index, $event)" v-on:blur="fieldBlur(form.items[index], index)">
              </div>
              <div v-else-if="item.type == 'select'">
                <span v-on:click="touchItem(index)">{{ stripSlashes(item.text) }}</span>
                <select v-model="form.items[index].value" v-on:change="fieldBlur(form.items[index], index)" v-on:click="fieldBlur(form.items[index], index)">
                  <option v-for="(option, i) in options" value="option['text']">{{ option.text }}</option>
                </select>
              </div>
            </div>
            <div class="boffo-item boffo-buttons" v-bind:class="{ active: activeItem >= form.items.length, queued: activeItem + 1 == form.items.length }">
              <button class="save-button" v-on:click="save()" v-bind:disabled="!isFormValid()">{{ stripSlashes(form.submit_button_text) }}</button>
            </div>
          </div>
          <div class="boffo-done">
            <p>{{ stripSlashes(form.confirmation_message) }}</p>
          </div>
        </div>
      `
    });
  });
})(jQuery);



// WEBPACK FOOTER //
// ./js/public.js